import {
  PlatformRole,
  User,
  canCreateProjects,
  canCreateUsers,
  canUpdateProjectFields,
} from '../../types/onboarding';

export interface RoutePermissionConfig {
  title: string;
  message: string;
  roleHintByRole?: Partial<Record<PlatformRole, string>>;
  allow: (user: User) => boolean;
}

export const userOnboardingPermission: RoutePermissionConfig = {
  title: 'User Creation',
  message: 'You do not have permission to onboard new users.',
  allow: (user) => canCreateUsers(user.platformRole),
  roleHintByRole: {
    admin:
      'Admins have global access across all organizations. If you expected access here, try refreshing the page.',
    developer:
      'Developers can only view assigned projects and edit their own profile details.',
    maintainer:
      'Maintainers can invite users and manage projects within their active organization.',
  },
};

export const projectCreatePermission: RoutePermissionConfig = {
  title: 'Project Onboarding',
  message: 'You do not have permission to onboard new projects.',
  allow: (user) => canCreateProjects(user.platformRole),
  roleHintByRole: {
    admin:
      'Admins have global access across all organizations. If you expected access here, try refreshing the page.',
    developer:
      'Developers can only view and work on projects they are explicitly assigned to.',
    maintainer:
      'Maintainers can create projects in their active organization. To edit an existing project, use View projects.',
  },
};

export const projectEditPermission: RoutePermissionConfig = {
  title: 'Edit project',
  message: 'You do not have permission to change project details or membership.',
  allow: (user) => canUpdateProjectFields(user.platformRole),
  roleHintByRole: {
    admin:
      'Admins have global access across all organizations. If you expected access here, try refreshing the page.',
    developer: 'Developers cannot edit project settings or team membership.',
    maintainer:
      'Maintainers can edit project dates and team membership in their active organization.',
  },
};
